import { motion } from "framer-motion";

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 } }),
};

export function Reveal({ children, i = 0, className = "", ...rest }) {
  return (
    <motion.div
      className={className}
      variants={fadeUp}
      custom={i}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-80px" }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = "", lineClassName = "", as: Tag = "h1", delay = 0 }) {
  const MTag = motion[Tag] || motion.h1;
  return (
    <MTag
      className={className}
      initial="hidden"
      animate="show"
      variants={{ hidden: {}, show: { transition: { staggerChildren: 0.14, delayChildren: delay } } }}
    >
      {lines.map((line, idx) => (
        <span key={idx} className="block overflow-hidden pb-1 -mb-1">
          <motion.span
            className={`block ${lineClassName}`}
            variants={{
              hidden: { y: "110%" },
              show: { y: "0%", transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] } },
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </MTag>
  );
}

export function SectionHeading({ kicker, title, className = "" }) {
  return (
    <div className={className}>
      <Reveal>
        <p className="font-mono text-xs md:text-sm uppercase tracking-[0.3em] text-hivis" data-testid={`kicker-${kicker?.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>{kicker}</p>
      </Reveal>
      <Reveal i={1}>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase leading-[0.95] tracking-tight text-slate-100 mt-3">
          {title}
        </h2>
      </Reveal>
    </div>
  );
}
